(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialize(root) {
    if (root.dataset.kobHomeEntryReady) return;
    root.dataset.kobHomeEntryReady = 'true';
    const entries = [...root.querySelectorAll('.kob-home-shopping-entry__link')];
    const timers = new Map();

    function stop(entry) {
      window.clearTimeout(timers.get(entry));
      timers.delete(entry);
      entry.classList.remove('is-active', 'is-drawing');
    }

    function play(entry) {
      window.clearTimeout(timers.get(entry));
      entry.classList.add('is-active');
      entry.classList.remove('is-drawing');
      if (!motionQuery.matches) {
        void entry.offsetWidth;
        entry.classList.add('is-drawing');
      }
      timers.set(entry, window.setTimeout(() => {
        entry.classList.remove('is-drawing');
        if (!entry.matches(':hover,:focus-visible')) stop(entry);
      }, 900));
    }

    entries.forEach(entry => {
      entry.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') play(entry);
      });
      entry.addEventListener('pointerleave', () => {
        if (!entry.matches(':focus-visible')) stop(entry);
      });
      entry.addEventListener('focus', () => play(entry));
      entry.addEventListener('blur', () => {
        if (!entry.matches(':hover')) stop(entry);
      });
      // Keep native navigation, keyboard activation and modified-click behavior.
      entry.addEventListener('click', () => play(entry));
    });

    motionQuery.addEventListener('change', () => entries.forEach(stop));
  }

  function initializeWithin(scope) {
    scope.querySelectorAll('[data-kob-home-shopping-entry]').forEach(initialize);
  }

  initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
})();
